module.exports = __webpack_public_path__ + "static/media/footer-choko.da012691.png";